import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { EncryptionContextProvider } from "./config/context/encryptionContext";
import { GuiContextProvider } from "./config/context/guiContext";
import { IDBProvider } from "./config/context/IDBcontext";
import { PluginsContextProvider } from "./config/context/pluginsContext";
import { PrivateKeyContextProvider } from "./config/context/privateKeyContext";
import { TableContextProvider } from "./config/context/tableContext";
import { ThemeContextProvider } from "./config/context/themeContext";
import { ToastContextProvider } from "./config/context/toastContext";
import { ModalContextProvider } from "config/context/modalContext";
import { AuthenticationContextProvider } from "config/context/authenticationContext";
import { ModalSystemProvider } from "config/context/ModalSystemContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <IDBProvider>
      <GuiContextProvider>
        <TableContextProvider>
          <ToastContextProvider>
            <ThemeContextProvider>
              <ModalContextProvider>
                <ModalSystemProvider>
                  <AuthenticationContextProvider>
                    <PrivateKeyContextProvider>
                      <PluginsContextProvider>
                        <EncryptionContextProvider>
                          <App />
                        </EncryptionContextProvider>
                      </PluginsContextProvider>
                    </PrivateKeyContextProvider>
                  </AuthenticationContextProvider>
                </ModalSystemProvider>
              </ModalContextProvider>
            </ThemeContextProvider>
          </ToastContextProvider>
        </TableContextProvider>
      </GuiContextProvider>
    </IDBProvider>
  </BrowserRouter>
);
